/**
 * Dropdown-visible chart-of-accounts hook, shared by the COGS and SIT account
 * pickers. Kept out of the component module so those files only export
 * components (react-refresh hygiene).
 */
import { trpc } from '@/lib/trpc';

export function useDropdownAccounts(enabled: boolean) {
  const query = trpc.xero.getAccounts.useQuery(
    { dropdownOnly: true },
    { enabled, staleTime: 5 * 60_000 }
  );
  return query.data ?? [];
}
